// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"388":"534f1d35","532":"styles","565":"component---src-templates-page-js"}[chunkId] + "-" + {"388":"d23b6015a463f8253cd1","532":"8ce85cfd3dd59d029453","565":"c6cdfe5078ccc86b01dc"}[chunkId] + ".js";
};